var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1785 12.9882C24.8294 13.639 24.8294 14.6943 24.1785 15.3452L19.5237 20L24.1785 24.6548C24.8294 25.3057 24.8294 26.361 24.1785 27.0118C23.5276 27.6627 22.4724 27.6627 21.8215 27.0118L15.9882 21.1785C15.3373 20.5276 15.3373 19.4724 15.9882 18.8215L21.8215 12.9882C22.4724 12.3373 23.5276 12.3373 24.1785 12.9882Z",
    fill: "#23262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevLeft);
export default __webpack_public_path__ + "static/media/chev-left.3195ca67f2dc01a52338bc00e2f01b6e.svg";
export { ForwardRef as ReactComponent };